<script>
    import { setupI18n, _ } from './i18n';
    import {apiRequest} from "./lib/Request.svelte";
    import RangeSlider from "svelte-range-slider-pips";

    export let showCalculator = false;

    export let locale;
    export let sliderValue = [100];


    setupI18n({ withLocale: locale });

    function showCalculationForm() {
        showCalculator = true;
    }

    function onSliderChange() {

    }


</script>


<div class="calculator-widget-wrap">
    <div class="form-wrap">
        <div class="intro-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" class="icon mr-21px w-40px">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1015 0.630066H38.8987C42.0401 0.630066 44.6102 3.20028 44.6102 6.34169V43.6583C44.6102 46.7998 42.04 49.3699 38.8987 49.3699H11.1015C7.96014 49.3699 5.38983 46.7997 5.38983 43.6583V6.34169C5.38983 3.20018 7.96005 0.630066 11.1015 0.630066ZM34.2336 37.8407C33.7065 37.8407 33.2278 38.056 32.8812 38.4025C32.5347 38.749 32.3194 39.2279 32.3194 39.755V41.6593C32.3194 42.1863 32.5347 42.6651 32.8812 43.0117C33.2278 43.3583 33.7065 43.5735 34.2336 43.5735H38.6132C39.1402 43.5735 39.619 43.3583 39.9656 43.0117C40.3122 42.6651 40.5274 42.1863 40.5274 41.6593V39.755C40.5274 39.2279 40.3121 38.7491 39.9656 38.4025C39.6191 38.0559 39.1402 37.8407 38.6132 37.8407H34.2336ZM38.6132 39.1946H34.2336C34.0803 39.1946 33.9401 39.2579 33.8385 39.3597C33.7368 39.4614 33.6734 39.6015 33.6734 39.755V41.6593C33.6734 41.8128 33.7367 41.9528 33.8385 42.0546C33.9402 42.1562 34.0803 42.2196 34.2336 42.2196H38.6132C38.7667 42.2196 38.9067 42.1563 39.0085 42.0546C39.1101 41.9528 39.1735 41.8128 39.1735 41.6593V39.755C39.1735 39.6015 39.1102 39.4614 39.0085 39.3597C38.9067 39.258 38.7666 39.1946 38.6132 39.1946ZM22.8102 37.8407C22.2832 37.8407 21.8044 38.056 21.4578 38.4025C21.1112 38.7491 20.896 39.2279 20.896 39.755V41.6593C20.896 42.1863 21.1113 42.6651 21.4578 43.0117C21.8044 43.3583 22.2832 43.5735 22.8102 43.5735H27.1896C27.7167 43.5735 28.1955 43.3583 28.5421 43.0117C28.8887 42.6651 29.1039 42.1863 29.1039 41.6593V39.755C29.1039 39.2279 28.8886 38.7491 28.5421 38.4025C28.1955 38.0559 27.7167 37.8407 27.1896 37.8407H22.8102ZM27.1897 39.1946H22.8103C22.6568 39.1946 22.5167 39.2579 22.415 39.3597C22.3133 39.4614 22.25 39.6015 22.25 39.755V41.6593C22.25 41.8128 22.3133 41.9528 22.415 42.0546C22.5167 42.1562 22.6568 42.2196 22.8103 42.2196H27.1897C27.3432 42.2196 27.4834 42.1563 27.585 42.0546C27.6868 41.9528 27.7501 41.8128 27.7501 41.6593V39.755C27.7501 39.6015 27.6868 39.4614 27.585 39.3597C27.4833 39.258 27.3432 39.1946 27.1897 39.1946ZM11.387 37.8407C10.8599 37.8407 10.3811 38.056 10.0346 38.4025C9.68798 38.7491 9.47274 39.2279 9.47274 39.755V41.6593C9.47274 42.1863 9.68798 42.6651 10.0346 43.0117C10.3811 43.3583 10.8599 43.5735 11.387 43.5735H15.7665C16.2935 43.5735 16.7724 43.3583 17.1189 43.0117C17.4655 42.6651 17.6807 42.1863 17.6807 41.6593V39.755C17.6807 39.2279 17.4655 38.7491 17.1189 38.4025C16.7724 38.0559 16.2935 37.8407 15.7665 37.8407H11.387ZM15.7664 39.1946H11.3869C11.2334 39.1946 11.0933 39.2579 10.9916 39.3597C10.8899 39.4614 10.8266 39.6015 10.8266 39.755V41.6593C10.8266 41.8128 10.8898 41.9528 10.9916 42.0546C11.0933 42.1562 11.2334 42.2196 11.3869 42.2196H15.7664C15.9199 42.2196 16.0599 42.1563 16.1617 42.0546C16.2634 41.9528 16.3267 41.8128 16.3267 41.6593V39.755C16.3267 39.6015 16.2635 39.4614 16.1617 39.3597C16.0599 39.258 15.9199 39.1946 15.7664 39.1946ZM34.2336 30.0347C33.7065 30.0347 33.2278 30.25 32.8812 30.5965C32.5347 30.9431 32.3194 31.4219 32.3194 31.9489V33.8532C32.3194 34.3803 32.5347 34.8591 32.8812 35.2057C33.2278 35.5522 33.7065 35.7675 34.2336 35.7675H38.6132C39.1402 35.7675 39.619 35.5521 39.9656 35.2057C40.3122 34.8591 40.5274 34.3803 40.5274 33.8532V31.9489C40.5274 31.4219 40.3121 30.9431 39.9656 30.5965C39.619 30.2499 39.1402 30.0347 38.6132 30.0347H34.2336ZM38.6132 31.3887H34.2336C34.0803 31.3887 33.9401 31.4519 33.8385 31.5537C33.7368 31.6554 33.6734 31.7955 33.6734 31.949V33.8533C33.6734 34.0068 33.7367 34.1469 33.8385 34.2486C33.9402 34.3503 34.0803 34.4137 34.2336 34.4137H38.6132C38.7667 34.4137 38.9067 34.3504 39.0085 34.2486C39.1101 34.1469 39.1735 34.0068 39.1735 33.8533V31.949C39.1735 31.7955 39.1102 31.6554 39.0085 31.5537C38.9067 31.4519 38.7666 31.3887 38.6132 31.3887ZM22.8102 30.0347C22.2832 30.0347 21.8044 30.25 21.4578 30.5965C21.1112 30.9431 20.896 31.4219 20.896 31.9489V33.8532C20.896 34.3803 21.1113 34.8591 21.4578 35.2057C21.8044 35.5522 22.2832 35.7675 22.8102 35.7675H27.1896C27.7167 35.7675 28.1955 35.5521 28.5421 35.2057C28.8887 34.8591 29.1039 34.3803 29.1039 33.8532V31.9489C29.1039 31.4219 28.8886 30.9431 28.5421 30.5965C28.1955 30.2499 27.7167 30.0347 27.1896 30.0347H22.8102ZM27.1897 31.3887H22.8103C22.6568 31.3887 22.5167 31.4519 22.415 31.5537C22.3133 31.6554 22.25 31.7955 22.25 31.949V33.8533C22.25 34.0068 22.3133 34.1469 22.415 34.2486C22.5167 34.3503 22.6568 34.4137 22.8103 34.4137H27.1897C27.3432 34.4137 27.4834 34.3504 27.585 34.2486C27.6868 34.1469 27.7501 34.0068 27.7501 33.8533V31.949C27.7501 31.7955 27.6868 31.6554 27.585 31.5537C27.4833 31.4519 27.3432 31.3887 27.1897 31.3887ZM11.387 30.0347C10.8599 30.0347 10.3811 30.25 10.0346 30.5965C9.68798 30.9431 9.47274 31.4219 9.47274 31.9489V33.8532C9.47274 34.3803 9.68798 34.8591 10.0346 35.2057C10.3811 35.5522 10.8599 35.7675 11.387 35.7675H15.7665C16.2935 35.7675 16.7724 35.5521 17.1189 35.2057C17.4655 34.8591 17.6807 34.3803 17.6807 33.8532V31.9489C17.6807 31.4219 17.4655 30.9431 17.1189 30.5965C16.7724 30.2499 16.2935 30.0347 15.7665 30.0347H11.387ZM15.7664 31.3887H11.3869C11.2334 31.3887 11.0933 31.4519 10.9916 31.5537C10.8899 31.6554 10.8266 31.7955 10.8266 31.949V33.8533C10.8266 34.0068 10.8898 34.1469 10.9916 34.2486C11.0933 34.3503 11.2334 34.4137 11.3869 34.4137H15.7664C15.9199 34.4137 16.0599 34.3504 16.1617 34.2486C16.2634 34.1469 16.3267 34.0068 16.3267 33.8533V31.949C16.3267 31.7955 16.2635 31.6554 16.1617 31.5537C16.0599 31.4519 15.9199 31.3887 15.7664 31.3887ZM34.2336 22.2286C33.7065 22.2286 33.2278 22.4439 32.8812 22.7904C32.5347 23.137 32.3194 23.6158 32.3194 24.1429V26.0472C32.3194 26.5742 32.5347 27.053 32.8812 27.3996C33.2278 27.7462 33.7065 27.9614 34.2336 27.9614H38.6132C39.1402 27.9614 39.619 27.7461 39.9656 27.3996C40.3122 27.0531 40.5274 26.5742 40.5274 26.0472V24.1429C40.5274 23.6158 40.3121 23.137 39.9656 22.7904C39.619 22.4438 39.1402 22.2286 38.6132 22.2286H34.2336ZM38.6132 23.5826H34.2336C34.0803 23.5826 33.9401 23.6459 33.8385 23.7476C33.7368 23.8493 33.6734 23.9894 33.6734 24.143V26.0473C33.6734 26.2008 33.7367 26.3409 33.8385 26.4426C33.9402 26.5442 34.0803 26.6076 34.2336 26.6076H38.6132C38.7667 26.6076 38.9067 26.5443 39.0085 26.4426C39.1101 26.3408 39.1735 26.2008 39.1735 26.0473V24.143C39.1735 23.9894 39.1102 23.8493 39.0085 23.7476C38.9067 23.6459 38.7666 23.5826 38.6132 23.5826ZM22.8102 22.2286C22.2832 22.2286 21.8044 22.4439 21.4578 22.7904C21.1112 23.137 20.896 23.6158 20.896 24.1429V26.0472C20.896 26.5742 21.1113 27.053 21.4578 27.3996C21.8044 27.7462 22.2832 27.9614 22.8102 27.9614H27.1896C27.7167 27.9614 28.1955 27.7461 28.5421 27.3996C28.8887 27.053 29.1039 26.5742 29.1039 26.0472V24.1429C29.1039 23.6158 28.8886 23.137 28.5421 22.7904C28.1955 22.4438 27.7167 22.2286 27.1896 22.2286H22.8102ZM27.1897 23.5826H22.8103C22.6568 23.5826 22.5167 23.6459 22.415 23.7476C22.3133 23.8493 22.25 23.9894 22.25 24.143V26.0473C22.25 26.2008 22.3133 26.3409 22.415 26.4426C22.5167 26.5442 22.6568 26.6076 22.8103 26.6076H27.1897C27.3432 26.6076 27.4834 26.5443 27.585 26.4426C27.6868 26.3408 27.7501 26.2008 27.7501 26.0473V24.143C27.7501 23.9894 27.6868 23.8493 27.585 23.7476C27.4833 23.6459 27.3432 23.5826 27.1897 23.5826ZM11.387 22.2286C10.8599 22.2286 10.3811 22.4439 10.0346 22.7904C9.68798 23.137 9.47274 23.6158 9.47274 24.1429V26.0472C9.47274 26.5742 9.68798 27.053 10.0346 27.3996C10.3811 27.7462 10.8599 27.9614 11.387 27.9614H15.7665C16.2935 27.9614 16.7724 27.7461 17.1189 27.3996C17.4655 27.053 17.6807 26.5742 17.6807 26.0472V24.1429C17.6807 23.6158 17.4655 23.137 17.1189 22.7904C16.7724 22.4438 16.2935 22.2286 15.7665 22.2286H11.387ZM15.7664 23.5826H11.3869C11.2334 23.5826 11.0933 23.6459 10.9916 23.7476C10.8899 23.8493 10.8266 23.9894 10.8266 24.143V26.0473C10.8266 26.2008 10.8898 26.3409 10.9916 26.4426C11.0933 26.5442 11.2334 26.6076 11.3869 26.6076H15.7664C15.9199 26.6076 16.0599 26.5443 16.1617 26.4426C16.2634 26.3408 16.3267 26.2008 16.3267 26.0473V24.143C16.3267 23.9894 16.2635 23.8493 16.1617 23.7476C16.0599 23.6459 15.9199 23.5826 15.7664 23.5826ZM11.7301 6.61659C11.1089 6.61659 10.544 6.8705 10.1353 7.27919C9.72665 7.68788 9.47274 8.25243 9.47274 8.87391V16.5653C9.47274 17.1865 9.72665 17.7514 10.1353 18.16C10.544 18.5687 11.1089 18.8227 11.7301 18.8227H38.27C38.8915 18.8227 39.456 18.5688 39.8647 18.16C40.2734 17.7514 40.5273 17.1865 40.5273 16.5653V8.87401C40.5273 8.25253 40.2734 7.68798 39.8647 7.27928C39.456 6.87059 38.8915 6.61669 38.27 6.61669L11.7301 6.61659Z" fill="#F8F8FA"/>
            </svg>
            <div class="description-wrap">
                <div class="row1">
                    Let's find out the price for you
                </div>
                <div class="row2">
                    Price calculator
                </div>
            </div>

            {#if !showCalculator}
                <div class="calc-btn-wrap text-center">
                    <button class="blue-btn w-140px calc-btn mx-auto" on:click={showCalculationForm}>
                        Calculate
                    </button>
                </div>
            {/if}

        </div>

        {#if showCalculator}
            <div>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="1" viewBox="0 0 30 1" fill="none">
                        <rect width="1" height="30" rx="0.5" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0)" fill="#F8F8FA" fill-opacity="0.4"/>
                    </svg>
                </div>
                <p>
                    Set the number of audiences on your account using the slider
                </p>
                <div class="range-wrap">
                    <RangeSlider min={100}
                                 max={10000}
                                 step={1}
                                 bind:values={sliderValue}
                                 pips={false}
                                 all="label"
                                 float
                                 suffix=" accounts"
                                 on:change={onSliderChange}
                                 handleFormatter={ function (v) {
                                     if (v === 10000) {
                                         return '> 10000';
                                     }

                                     return v;
                                 }}
                    />
                </div>

                <div class="tariff-info-wrap mb-20px">
                    <div class="standard-tariffs mb-30px">
                        <div class="month-wrap">
                            <div class="tariff-title">
                                Monthly
                            </div>
                            <div class="tariff-value">
                                $ХХ /month
                            </div>
                        </div>
                        <div class="six-months-wrap">
                            <div class="tariff-title">
                                6-month access
                            </div>
                            <div class="tariff-value">
                                $ХХХ /6 month
                            </div>
                        </div>
                    </div>
                    <div class="premium-tariff">
                        <div class="tariff-title">
                            Spamguard Premium
                        </div>
                        <div class="tariff-value">
                            $ХХХ /month
                        </div>
                    </div>
                </div>

                <div class="mb-20px">
                    <button class="blue-btn w-140px mx-auto">Start now</button>
                </div>

                <div class="post-info-wrap">
                    <div class="mb-20px">
                        We use progressive pricing, as the scope of your account determines the amount of Spamguard resources that will be used to manage it.
                    </div>
                    <div>
                        For a more detailed estimate of your pricing - add the account you are interested in your Dashboard and go to section Tariffs
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    @media (max-width:768px) {
        .calc-btn-wrap {
            flex: 0 0 100%;
            width: 100%;
        }

        .standard-tariffs > .month-wrap {
            margin-bottom: 30px;
        }
    }
    .standard-tariffs {
        display: flex;
        flex-wrap: wrap;
    }
    .standard-tariffs > div {
        flex-grow: 1;
    }
    .tariff-title {
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFE;
    }
    .tariff-value {
        font-weight: 400;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFE;
    }
    .post-info-wrap {
        font-weight: 300;
        font-size: 14px;
        line-height: 17px;
        color: #F8F8FA;
    }
    .text-center {
        text-align: center;
    }
    .description-wrap {
        flex-grow: 1;
    }
    .description-wrap .row1 {
        font-weight: 300;
        font-size: 14px;
        line-height: 17px;
        color: #F8F8FA;
    }
    .description-wrap .row2 {
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #F8F8FA;
    }
    .calc-btn-wrap {
        width: 140px;
    }

    .blue-btn {
        display: block;
        height: 37px;
        background: linear-gradient(92.34deg, #606FE3 0%, #4783FE 100%);
        border-radius: 8px;
        color: #fff;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.07em;
        border: none;
    }
    .form-wrap {
        background: linear-gradient(119.6deg, #2C2346 -1.78%, #524A69 -1.77%, #23163D 100%);
        border: 1px solid #453E59;
        box-shadow: 7px 8px 13px rgba(0, 0, 0, 0.23);
        border-radius: 16px;
        color: #fff;
        padding: 42px 24px;
    }

    .form-wrap .intro-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .break {
        flex-basis: 100%;
        height: 0;
    }

    .inline {
        display: inline;
    }

    .mx-auto {
        margin-right: auto;
        margin-left: auto;
    }

    .mb-10px {
        margin-bottom: 10px;
    }
    .mb-20px {
        margin-bottom: 20px;
    }
    .mb-30px {
        margin-bottom: 30px;
    }

    .mr-10px {
        margin-right: 10px;
    }
    .mr-21px {
        margin-right: 21px;
    }

    .w-40px {
        width: 40px;
    }
    .w-140px {
        width: 140px;
    }
    .maxw-140px {
        max-width: 140px;
    }
    .minw-40px {
        min-width: 40px;
    }

    @-moz-keyframes spin {
        100% { -moz-transform: rotate(360deg); }
    }
    @-webkit-keyframes spin {
        100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform:rotate(360deg);
        }
    }
    .spinner {
        -webkit-animation:spin 2s linear infinite;
        -moz-animation:spin 2s linear infinite;
        animation:spin 2s linear infinite;
    }


</style>